import debounce from "p-debounce";
const debounceWithPromise = debounce;
export default debounceWithPromise;
